<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.unidades"
                    :validations="validations.unidadeId"
                    @change="handleUnidadeIdChange"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.unidadeId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.infraestruturas"
                    :validations="validations.infraestruturaId"
                    label="Local de atendimento"
                    show-default-option
                    text-field="nome"
                    v-model="model.infraestruturaId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-checkbox
                    inline
                    v-model="model.responsavel"
                >
                    Responsável
                </rkm-form-checkbox>

                <rkm-form-checkbox
                    inline
                    v-model="model.permiteAplicacao"
                >
                    Permitir aplicação
                </rkm-form-checkbox>

                <rkm-form-checkbox
                    inline
                    v-model="model.permiteRequisicao"
                >
                    Permitir requisição
                </rkm-form-checkbox>

                <rkm-form-checkbox
                    inline
                    v-model="model.criaFichaAb"
                >
                    Criar ficha AB
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {
            return {
                unidadeId: { required: true },
                infraestruturaId: { required: true },
            }
        },
    },
    created() {
        this.repositories = {
            salaVacinacao: this.getConectaSusRepository('imunizacao.salaVacinacao')
        }
    },
    data: () => ({
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            if (this.id) {
                this.repositories.salaVacinacao.edit(this.id)
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())

            } else {
                this.repositories.salaVacinacao.create()
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleUnidadeIdChange(id) {
            this.model.infraestruturaId = null

            const request = {
                listar: 'infraestruturas',
                unidadeId: id,
            }

            this.setLoading()

            this.repositories.salaVacinacao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.infraestruturas = Object.assign(response.data)

                    if (this.form.infraestruturas.length === 1) {
                        const selected = this.form.infraestruturas[0]
                        this.model.infraestruturaId = selected.id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid) {
                        this.setLoading()

                        if (this.model.id) {
                            this.repositories.salaVacinacao
                                .update(this.model.id, this.camelObjectKeysToSnakeRecursive(this.model))
                                .then(response => {
                                    this.showSaveNotification()
                                    this.$emit('save', response)
                                })
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading())
                        } else {
                            this.repositories.salaVacinacao.store(this.camelObjectKeysToSnakeRecursive(this.model))
                                .then(response => {
                                    this.showSaveNotification()
                                    this.$emit('save', response)
                                })
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading())
                        }
                    }
                })
        },
    },
    mixins: [ error, repository, stringCase ],
    mounted() {
        this.load()
    },
    props: {
        id: { type: [Number, String], default: null },
    },
}
</script>